export class Da5100Class {


    EmpId:number;
    EmpNo:string;
    AttendanceId :number;
    FkCompId:number;
    ReferenceNo:string
    FkEmpId:number;
    FkContractId:number;
    TransactionDate:Date;
    // TransactionDateOut:Date;
    TransactionDateOut: Date | null;
    FromDate:Date;
    ToDate:Date;
    InTime:string;
    OutTime:string;
    WorkDays:number;
    FkProjectId:number;
    FkShiftId:number;
    FkPayHeadId:number;
    WorkedHrs:string;
    OtHrs:string;
    Remarks:string;
    ApprovalStatus:number;
    ProcessStatus:number;

    StrTransactionDate:string;
    StrTransactionDateOut:string;
    StrFromDate:string;
    StrToDate:string;

    EmployeeName:string;
    PayHeadCode:string;
    PayHeadName:string;
    ProcessedCount:number;
    MdfdBy: number;
    MdfdOn: Date;
    da5100History: Da5100Class;
    StrProcessStatus:string;
    Da5100List: Array<Da5100Class> = [];
    coordinatelat:number;
    coordinatelong:number;

    AssignedShiftList: any[] = [];
    ActualShiftList: any[] = [];

    Assignedshift: number;
    Actualshift: number;    

  
}
